import React, { useState } from "react";

import "./style.css";

import { produtos } from "../../data/product";

const Section = () => {
  const [busca, setBusca] = useState("");
  const [resultados, setResultados] = useState([]);
  const [buscou, setBuscou] = useState(false);

  const handleBuscar = () => {
    const resultadoFiltrado = produtos.filter((produto) =>
      produto.nome.toLowerCase().includes(busca.toLowerCase())
    );
    setResultados(resultadoFiltrado);
    setBuscou(true);
  };

  const handleContato = (mensagemPersonalizada) => {
    const mensagem =
      mensagemPersonalizada ||
      "Olá, estou procurando uma peça específica e não encontrei no site.";
    const link = `https://wa.me/5544991419595?text=${encodeURIComponent(
      mensagem
    )}`;
    window.open(link, "_blank");
  };

  return (
    <section className="pecas-section">
      <div className="pecas-info">
        <h2>Encontre a peça certa em segundos</h2>
        <p>
          Busque por categoria, marca ou modelo do caminhão. Tudo em um só
          lugar.
        </p>
        <div className="busca-box">
          <input
            type="text"
            placeholder="Ex: Filtro de óleo para Scania R440"
            value={busca}
            onChange={(e) => setBusca(e.target.value)}
          />
          <button onClick={handleBuscar}>Buscar Peça</button>
        </div>
      </div>

      {buscou && resultados.length > 0 && (
        <div className="resultados">
          <h3>Resultados encontrados:</h3>
          <div className="produtos-lista">
            {resultados.map((produto) => (
              <div className="produto" key={produto.id}>
                <img src={produto.imagem} alt={produto.nome} />
                <p>{produto.nome}</p>
                <button
                  onClick={() =>
                    handleContato(
                      `Olá, quero informações sobre: ${produto.nome}`
                    )
                  }
                >
                  Falar com Especialista
                </button>
              </div>
            ))}
          </div>
        </div>
      )}

      {buscou && resultados.length === 0 && (
        <div className="sem-resultados">
          <h3>Produto não encontrado no Site.</h3>
          <p>
            Mas não se preocupe! Clique abaixo e fale com um especialista para
            encontrar a peça certa.
          </p>
          <button onClick={() => handleContato()}>
            Falar com Especialista via WhatsApp
          </button>
        </div>
      )}
    </section>
  );
};

export default Section;
